import { render, staticRenderFns } from "./ztList.vue?vue&type=template&id=41182a08&scoped=true"
import script from "./ztList.vue?vue&type=script&lang=js"
export * from "./ztList.vue?vue&type=script&lang=js"
import style0 from "./ztList.vue?vue&type=style&index=0&id=41182a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41182a08",
  null
  
)

export default component.exports